import React from 'react'
import RocketImg from '../../images/rocket.svg'
import './empty.css'

const Empty = ({title, desc}) => {

      return (
            <div className="page_empty flex">
                  <div className="empty_image flex">
                        <img src={RocketImg} alt="Empty illustration" />
                  </div>
                  <h2>{title}</h2>
                  <p>{desc}</p>
            </div>
      )
}

export default Empty
